import type { CSSProperties } from 'react';
import { isFunction } from 'lodash-es';
import { ButtonBar } from '../../buttons/button-bar';
import { PrimaryButton } from '../../buttons/primary/primary-button';
import { SecondaryButton } from '../../buttons/secondary/secondary-button';
import { withClose } from '../atoms/helpers';
import type { ClickHandler } from '../atoms/helpers';
import { useModalContext } from '../provider/modal.provider';
import { fullscreenModalActions } from './fullscreen-modal.styles';

type Props = {
  actionName?: string;
  cancelName?: string;
  disableAction?: boolean;
  onAction: ClickHandler;
  onCancel?: ClickHandler;
  actionTrackingId?: string;
  cancelTrackingId?: string;
  className?: string;
  maxWidth?: number;
};

export const FullscreenModalActions = ({
  onAction,
  onCancel,
  actionName = 'Save',
  cancelName = 'Cancel',
  disableAction,
  cancelTrackingId,
  actionTrackingId,
  maxWidth,
}: Props) => {
  const { onClose } = useModalContext();

  return (
    <ButtonBar
      className={fullscreenModalActions}
      style={
        maxWidth != null ? ({ '--fullscreen-modal-actions-max-width': `${maxWidth}px` } as CSSProperties) : undefined
      }
    >
      {isFunction(onCancel) && (
        <SecondaryButton onClick={withClose(onClose, onCancel)} trackingId={cancelTrackingId}>
          {cancelName}
        </SecondaryButton>
      )}
      <PrimaryButton onClick={withClose(onClose, onAction)} disabled={disableAction} trackingId={actionTrackingId}>
        {actionName}
      </PrimaryButton>
    </ButtonBar>
  );
};
